import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "no-data-page"
};
const _hoisted_2 = {
  class: "empty-text"
};
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'no-data',
  props: {
    emptyText: {
      type: String,
      default: '暂无数据'
    }
  },
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "no-data",
        src: _imports_0,
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_2, _toDisplayString(__props.emptyText), 1)]);
    };
  }
});